"use strict";

import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

import Section from "../../Template/Section";
import Row from "../../Layout/Row";
import Col from "../../Layout/Col";
import InfoBox from "../../Widget/InfoBox";
import { NumberFormat, PercentageFormat } from "../../Util/NumberFormat"
import {filterContextToRequestParams, onFilterContextDidUpdate} from "../../../context/FilterContext/Util";

import {apiPath} from "../../../const";
import {getRequest} from "../../../service/api/request";

const SummaryReport = withRouter(class SummaryReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            summary: {
                count: 0,
                countAvailable: 0,
                countErrors: 0,
                countWarnings: 0,
                countInfo: 0,
                countUnknown: 0,
            },
        };
    }

    componentWillMount() {
        this.fetchReport();

        this.fetchDataTimerHandle = 0;
    }

    componentDidMount() {
        this.fetchDataTimerHandle = setInterval(() => this.fetchReport(), 60000);
    }

    componentWillUnmount() {
        clearInterval(this.fetchDataTimerHandle);
    }

    componentDidUpdate(prevProps, prevState) {
        onFilterContextDidUpdate(prevProps.filterContext,
                                 this.props.filterContext,
                                 () => this.fetchReport());
    }

    fetchReport() {
        const { loading } = this.state;

        if (loading) return;

        this.setState({ loading: true });

        const retportApiPath = apiPath + "/enrichedVideos/search/generateSummaryReport";

        let params = filterContextToRequestParams(this.props.filterContext);

        getRequest(
            retportApiPath,
            params
        )
        .then(response => {
            const summary = response.entity;
            this.setState({summary});
        })
        .catch(reason => {

        })
        .finally(() => {
            this.setState({ loading: false });
        });
    }

    render() {
        const { summary } = this.state;

        return (
            <div>
                <Section className="content-header">
                    <h1>Summary</h1>
                </Section>
                <Section className="content">
                    <Row>
                        <Col lg="5ths" md="6" sm="6" xs="12">
                            <Link to="/enriched-videos">
                                <InfoBox icon="film"
                                         header="Scheduled"
                                         content={NumberFormat(summary.count)} />
                            </Link>
                        </Col>
                        <Col lg="5ths" md="6"sm="6" xs="12">
                            <Link to="/enriched-videos-in-catalogue">
                                <InfoBox icon="check-circle"
                                         iconBgColor="green"
                                         header="Available"
                                         content={<span>
                                                      {NumberFormat(summary.countAvailable)}<br />
                                                      {PercentageFormat(summary.countAvailable/(summary.count || 1))}<br />
                                                  </span>}
                                />
                            </Link>
                        </Col>
                        <Col lg="5ths" md="6"sm="6" xs="12">
                            <Link to="/enriched-videos-by-violation/ERROR">
                                <InfoBox icon="ban"
                                         iconBgColor="red"
                                         header="Errors"
                                         content={<span>
                                                      {NumberFormat(summary.countErrors)}<br />
                                                      {PercentageFormat(summary.countErrors/(summary.count || 1))}<br />
                                                  </span>}
                                />
                            </Link>
                        </Col>
                        <Col lg="5ths" md="6"sm="6" xs="12">
                            <Link to="/enriched-videos-by-violation/WARNING">
                                <InfoBox icon="exclamation-triangle"
                                         iconBgColor="yellow"
                                         header="Warnings"
                                         content={<span>
                                                      {NumberFormat(summary.countWarnings)}<br />
                                                      {PercentageFormat(summary.countWarnings/(summary.count || 1))}<br />
                                                  </span>}
                                />
                            </Link>
                        </Col>
                        <Col lg="5ths" md="6"sm="6" xs="12">
                            <Link to="/enriched-videos-by-violation/INFO">
                                <InfoBox icon="info-circle"
                                         iconBgColor="light-blue"
                                         header="Info"
                                         content={<span>
                                                      {NumberFormat(summary.countInfo)}<br />
                                                      {PercentageFormat(summary.countInfo/(summary.count || 1))}<br />
                                                  </span>}
                                />
                            </Link>
                        </Col>
{/*
                        <Col lg="2" md="6"sm="6" xs="12">
                            <Link to="/enriched-videos-by-violation/UNKNOWN">
                                <InfoBox icon="question-circle"
                                         iconBgColor="gray"
                                         header="Unknown"
                                         content={<span>
                                                      {NumberFormat(summary.countUnknown)}<br />
                                                      {PercentageFormat(summary.countUnknown/(summary.count || 1))}<br />
                                                  </span>}
                                />
                            </Link>
                        </Col>
*/}
                    </Row>
                </Section>
            </div>
        )
    }
});

export default SummaryReport;
